$(function(){
  height = $(window).height()-50;
  $('.item').css('height',height+'px')
  $('body').css('height',height+'px')
});
